export class DateUtils {
  static formatDate = (v?: string): string | undefined => {
    if (!v) return v;
    const parts = v!.split('T')[0].split('-');
    parts.reverse();
    return parts.join('.');
  };
}
